<!-- 文件的树形结构 -->
<template>
  <div class="PublicFileTree">
    <div class="FileTreeTop">
      <!--拖拽头部标题-->
      <div class="searchTitle">
        <!-- 头部标题 -->
        <div style="margin-right:15px">
          <el-tooltip
          placement="top"
          effect="light"
          popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t('lang.MultiMode') }}</div>
            </div>
            <i :class="['iconfont', 'icon-selected', { selected: SelectTotalNumber.switch}]" @click="multipleFlag"></i>
          </el-tooltip>
          <el-tooltip
          placement="top"
          effect="light"
          popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t('lang.search') }}</div>
            </div>
            <i
            class="iconfont icon-search pointer"
            @click="searchShow()"
            ></i>
          </el-tooltip>
          <el-tooltip
            placement="top"
            effect="light"
            popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t("lang.addFolder") }}</div>
            </div>

            <i
              :disabled="CloneDisabled.VideoAdd||CloneDisabled.disableButton"
              class="iconfont icon-addfolder"
              @click="showAddFolder"></i>
          </el-tooltip>
          <el-tooltip
            placement="top"
            effect="light"
            popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t("lang.uploadVideoLocal") }}</div>
            </div>
            <i
              :disabled="CloneDisabled.VideoAdd||CloneDisabled.disableButton"
              class="iconfont pointer"
              @click="showUploadVideo">&#xe6ce;</i>
          </el-tooltip>
          <el-tooltip
            placement="top"
            effect="light"
            popper-class="videoUploadTip">
            <div slot="content">
              <div>{{ $t("lang.Refresh") }}</div>
            </div>
            <i class="iconfont icon-refresh" :disabled="CloneDisabled.disableButton"  @click="RefreshList"></i>
          </el-tooltip>
        </div>
      </div>
      <!-- 搜索框 -->
      <div
        class="searchInput"
        v-if="fileInput">
        <el-input
          ref="ResourceSearch"
          v-model="searchFileParam.condition"
          :placeholder="$t('lang.fileName')"
          @keyup.enter.native="getSearchFile"></el-input>
        <i
          class="iconfont icon-search pointer"
          @click="getSearchFile"></i>
      </div>
    </div>
    <!-- 下面的文件树 -->
    <div class="FileTreeScroll" v-loading='searchFileLoading'>
      <div class="draggable_box">
        <div
          class="FileTree"
          v-if="!searchFileParam.IsSearch">
          <!-- 加key区分两个树，不进行复用 -->
          <el-tree
            :props="props"
            lazy
            :load="loadNode"
            @node-click="getCurrentNode"
            :key="1"
            empty-text="No Data">
            <div
              class="TreeWrap"
              slot-scope="{ node, data }"
              >
              <div v-if="!data.noData">
                <div
                  class="folderItem"
                  v-if="!data.directory">
                  <p class="fileTitle" :title="node.label">
                    {{ node.label }} {{ MediaNumber(node) }}
                  </p>
                  <div class="folderOperation" v-if="data.fileFrom!=1">
                    <i
                      :disabled="CloneDisabled.VideoAdd||CloneDisabled.disableButton"
                      class="iconfont icon-addfolder"
                      @click.stop="changeFolder(0, node)"></i>
                    <i
                      :disabled="CloneDisabled.VideoEdit||CloneDisabled.disableButton"
                      class="iconfont icon-bianji"
                      @click.stop="changeFolder(1,node)"></i>
                    <i
                      :disabled="CloneDisabled.VideoDelete||CloneDisabled.disableButton"
                      class="iconfont icon-icon14"
                      @click.stop="deleteFolder(node)"></i>
                  </div>
                </div>
                <div
                  class="draggable_item draggableFile"
                  :draggable="CloneDisabled.disableButton||CloneDisabled.Drag?'false':'true'"
                  :data-device="JSON.stringify(data)"
                  v-else>
                  <div class="checkbox" v-if="SelectTotalNumber.switch" @click.stop="SelectFile(data, node)">
                    <div class="checkWrap" v-if="IsCheck(data.id)">
                      <span>{{FileOrder(data.id)}}</span>
                      <i class="iconfont icon-checkbox1"></i>
                    </div>
                    <i class="iconfont icon-yduifuxuankuang" v-else></i>
                  </div>
                  <p class="fileTitle" :title="TitleAndUpdate(node)">{{ node.label }}</p>
                  <div class="fileOperation" >
                    <div class="IconWrap" v-if="data.fileFrom!=1">
                      <i
                       v-if="IsJson(node)"
                       :disabled="CloneDisabled.VideoDownload||CloneDisabled.disableButton"
                       class="iconfont icon-download"
                       @click.stop="DownloadJson(node)"></i>
                      <i
                        :disabled="CloneDisabled.VideoEdit||CloneDisabled.disableButton"
                        class="iconfont icon-bianji"
                        @click.stop="changeFile(node)"></i>
                      <i
                        :disabled="CloneDisabled.VideoDelete||CloneDisabled.disableButton"
                        class="iconfont icon-icon14"
                        @click.stop="deleteFile(node)"></i>
                    </div>
                    <div class="FileTime">
                      {{ formatSeconds(data.videoTimes,data.name) }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="noData"
                v-else>
                {{ $t('lang.noData') }}
              </div>
            </div>
          </el-tree>
        </div>
        <div
          class="searchFileTree"
          v-else>
          <el-tree
            :data="searchFileList"
            :props="searchListProps"
            :default-expand-all="true"
            @node-click="getCurrentNode"
            :key="2">
            <div
              class="TreeWrap"
              slot-scope="{ node, data }">
              <div>
                <div
                  class="folderItem"
                  v-if="!data.directory">
                  <p class="fileTitle" :title="node.label">{{ node.label }}</p>
                </div>
                <div
                  class="draggable_item draggableFile"
                  :draggable="CloneDisabled.disableButton?'false':'true'"
                  :data-device="JSON.stringify(data)"
                  v-else>
                  <div class="checkbox" v-if="SelectTotalNumber.switch" @click.stop="SelectFile(data, node)">
                    <div class="checkWrap" v-if="IsCheck(data.id)">
                      <span>{{FileOrder(data.id)}}</span>
                      <i class="iconfont icon-checkbox1"></i>
                    </div>
                    <i class="iconfont icon-yduifuxuankuang" v-else></i>
                  </div>
                  <p class="fileTitle" :title="TitleAndUpdate(node)">{{ node.label }}</p>
                  <div class="fileOperation" >
                    <div class="IconWrap" v-if="data.fileFrom!=1">
                      <i
                       v-if="IsJson(node)"
                       :disabled="CloneDisabled.VideoDownload||CloneDisabled.disableButton"
                       class="iconfont icon-download"
                       @click.stop="DownloadJson(node)"></i>
                      <i
                        :disabled="CloneDisabled.VideoEdit||CloneDisabled.disableButton"
                        class="iconfont icon-bianji"
                        @click.stop="changeFile(node)"></i>
                      <i
                        :disabled="CloneDisabled.VideoEdit||CloneDisabled.disableButton"
                        class="iconfont icon-icon14"
                        @click.stop="deleteFile(node)"></i>
                    </div>
                    <div class="FileTime">
                      {{ formatSeconds(data.videoTimes,data.name) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tree>
        </div>

        <EditMedia
          v-if="editMedia.show"
          :data="editMedia"
          @queryFile="operationSuccess"></EditMedia>
        <AddEditFolder
          v-if="editFolder.show"
          @queryFolder="operationSuccess"
          :data="editFolder"></AddEditFolder>
        <!-- 上传视频   -->
        <UploadVideo
          v-if="uploadVideo.show"
          :data="uploadVideo"
          :session="uploadVideo.session"
          @queryList="operationSuccess"></UploadVideo>
      </div>
    </div>
    <div class="SelectTotalNumber" v-if="SelectTotalNumber.switch">
      <div class="TotalNumber">{{$t('lang.TotalNumber')}} <span>{{SelectTotalNumber.TotalNumber}}</span></div>
      <div class="TotalDuration">{{$t('lang.TotalDuration')}} <span>{{SelectTotalNumber.TotalDuration}}</span>
        <span class="batchDelete"><i class="iconfont icon-icon14" @click="batchDelete"></i></span>
      </div>
    </div>
    <!-- 单个和批量删除文件提示 -->
    <batch-delete-file :HintMessageList="HintMessageList" v-if="HintMessageList.switch" @ConfirmBatchDelete="ConfirmDelete" @CancelBatchDelete="CancelBatchDelete"></batch-delete-file>
    <!-- 剪辑json文件 -->
    <ClipVideo v-if="isIframeShow" @IframeShowChange="isIframeShow=false" :isIframeShow="isIframeShow" :currentData="currentData" :iframeData="iframeData"></ClipVideo>
  </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
import EditMedia from '@/components/file/EditMedia'
import AddEditFolder from '@/components/file/AddEditFolder'
import UploadVideo from '@/views/Playout/UploadVideo/UploadVideo'
import Bus from '@/assets/js/vueBus.js'
import Outil from '@/assets/js/utils.js'
import { mapState, mapMutations } from 'vuex'
import { searchIframe } from '@/assets/js/TVUSearch'
import ClipVideo from '@/components/common/search/ClipVideo.vue'
import { componentsAnalyze, scheduleAnalyze, playoutAnalyze } from '../../assets/js/googleAnalyze/playout.js'
import commonRequest from '@/assets/js/common/commonRequest.js'
import BatchDeleteFile from '@/components/file/BatchDeleteFile.vue'
export default {
  props: {
    // 刷新节点
    renderNode: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      State: (state) => state,
      CloneDisabled: (state) => state.playout.CloneDisabled,
      // 多选选中的文件夹
      PitchOnFileList: (state) => state.playout.PitchOnFileList
    }),
    // 判断是否选中
    IsCheck () {
      return (id) => !!this.PitchOnFileList[id]
    },
    // media数量变化修改文件夹显示
    MediaNumber () {
      return (data) => {
        let mediaCount = 0
        const childNodes = data.childNodes.length
        if (childNodes) {
          data.childNodes.forEach((item) => {
            if (!item.data || item.data.noData) return
            if (item.data.directory) {
              mediaCount++
            } else {
              mediaCount += item.data.mediaCount
            }
          })
        } else {
          mediaCount = data.data ? data.data.mediaCount : 0
        }
        data.data.mediaCount = mediaCount
        // const mediaCountText = mediaCount ? ' (' + mediaCount + ')' : ''
        return mediaCount ? ' (' + mediaCount + ')' : ''
      }
    }
  },
  data () {
    return {
      RefreshSwitch: true,
      // true文件false搜索文件
      FileTree: true,
      // bucket
      bucket: '',
      // 列表配置
      props: {
        label: 'name',
        children: 'childNodes',
        isLeaf: 'directory',
        mediaCount: 'mediaCount'
      },
      // 第一级id
      NodeHeadId: 0,
      // 存储所有点开的父级节点
      parentMap: {},
      // 当前节点
      presentNode: {},
      // 文件夹的操作信息
      editFolder: {
        show: false,
        name: '',
        parentId: '',
        id: '',
        type: 0 // 0创建 1编辑
      },
      // 文件的操作信息
      editMedia: {
        show: false
      },
      // 搜索信息
      searchFileParam: {
        condition: '',
        IsSearch: 0
      },
      // 是否显示搜索框
      fileInput: false,
      // 搜索到的列表
      searchFileList: [],
      // 搜索列表显示配置
      searchListProps: {
        label: 'name',
        children: 'sonFileInfo'
      },
      // 上传视频
      uploadVideo: {
        show: false,
        session: Outil.getSession()
      },
      pageMark: '',
      driveId: '',
      // 选中文件列表
      pitchOnFileList: [],
      // 选择数量和开关
      SelectTotalNumber: {
        TotalNumber: 0,
        TotalDuration: '00:00:00',
        switch: false
      },
      searchFileLoading: false,
      // 剪切之后文件存错文件夹id
      CutFolderID: '',
      // 是否显示全部文件
      isAll: false,
      // 重复搜索
      SearchRepeat: false,
      // 剪辑iframe开关
      isIframeShow: false,
      // 编辑文件信息
      currentData: {},
      // iframe传参
      iframeData: {},
      // 计算文件数量
      CountFileNum: false,
      // 消息提示列表
      HintMessageList: {
        switch: false,
        loading: false,
        isBatch: false,
        node: null,
        list: []
      },
      // 多选文件对应的文件夹
      multipleFileFolder: {}
    }
  },
  components: {
    EditMedia,
    AddEditFolder,
    UploadVideo,
    ClipVideo,
    BatchDeleteFile
  },
  watch: {
    // 刷新第一层节点
    renderNode (item) {
      this.RefreshFirstFloor()
    },
    // 多选选中文件变化
    PitchOnFileList (NewData) {
      const keys = Object.keys(NewData)
      let TotalDuration = 0
      keys.forEach((key) => {
        TotalDuration += NewData[key].videoTimes ? Number(NewData[key].videoTimes) : 0
      })
      this.SelectTotalNumber.TotalDuration = this.formatSeconds(TotalDuration)
      this.SelectTotalNumber.TotalNumber = keys.length
    }
  },
  created () {
    this.searchFileLoading = true
    this.bucket = this.$BehaviorSyns.getRegionBucket('bucket')
  },
  mounted () {
    this.getCurrentPage()
  },
  methods: {
    ...mapMutations('playout', ['SetPitchOnFileList']),
    // 刷新第一层节点
    RefreshFirstFloor () {
      this.$nextTick(() => {
        this.presentNode = {
          id: this.NodeHeadId
        }
        this.ClearParentMap()
        this.emptySelect()
        this.operationSuccess()
      })
    },
    // 多选文件排序
    FileOrder (id) {
      const keys = Object.keys(this.PitchOnFileList)
      const Order = keys.indexOf(id) + 1
      if (Order > 0) {
        return Order
      }
      return 1
    },
    // 多选开关
    multipleFlag () {
      if (this.SelectTotalNumber.switch) {
        this.emptySelect()
      }
      this.SelectTotalNumber.switch = !this.SelectTotalNumber.switch
    },
    // 清空选择
    emptySelect () {
      this.SetPitchOnFileList({})
    },
    // 选择文件
    SelectFile (data, node) {
      this.SetPitchOnFileList(data)
      // 保存文件对应的文件夹
      this.setPitchFolder(data, node)
    },
    // 保存多选文件对应的文件夹
    setPitchFolder (data, node) {
      this.multipleFileFolder[data.parentId] = node.parent
    },
    // 获取当前页面
    getCurrentPage () {
      this.pageMark = window.location.hash.split('#')[1]
    },
    // 刷新文件列表
    RefreshList () {
      if (this.CloneDisabled.disableButton) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeHeaderRefreshList', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeHeaderRefreshList', '/pop')
      }
      this.emptySelect()
      if (this.searchFileParam.IsSearch) {
        this.getSearchFile()
      } else {
        if (!this.RefreshSwitch) return
        this.RefreshSwitch = false
        this.presentNode = {
          id: this.NodeHeadId
        }
        this.ClearParentMap()
        this.operationSuccess('refresh')
      }
    },
    // 文件的title加更新时间
    TitleAndUpdate (data) {
      let update = ''
      if (typeof data.data.updateTime == 'number') {
        update = this.transitionHourly(new Date(data.data.updateTime * 1000))
        return `${data.label} UpdateTime: ${update}`
      }
      return data.label
    },
    transitionHourly (time) {
      if (time) {
        let type = ''
        const date = Outil.changeNewDate(time.getTime())
        let hour = time.getHours()
        let min = time.getMinutes()
        let s = time.getSeconds()
        const TimeFormat = Outil.getDateTimeFormat()
        if (TimeFormat.broadcastTimeFormat) {
          hour = hour >= 0 && hour < 10 ? `0${hour}` : hour
        } else if (hour >= 0 && hour <= 11) {
          type = 'AM'
          hour = hour == 0 ? 12 : hour
        } else {
          type = 'PM'
          hour = hour == 12 ? hour : hour - 12
        }
        min = min >= 0 && min < 10 ? `0${min}` : min
        s = s >= 0 && s < 10 ? `0${s}` : s
        return `${date} ${hour}:${min}:${s} ${type}`
      }
    },
    // 懒加载节点内容
    loadNode (node, resolve, type) {
      // 存储所有点开的父级节点
      this.parentMap[node.id] = {
        node,
        resolve
      }
      // 一级节点处理
      if (node.level === 0) {
        this.NodeHeadId = node.id
        this.getNodeContent(0, resolve, type)
      }
      // 其余节点的处理
      if (node.level >= 1) {
        this.getNodeContent(node, resolve, type)
      }
    },
    // 让:load=loadNode 重复触发  动态更新tree
    requestNewData (presentNode, type) {
      this.$set(presentNode.node, 'childNodes', []) // 把存起来的node的子节点清空，不然会界面会出现重复树！);
      this.loadNode(presentNode.node, presentNode.resolve, type) // 再次执行懒加载的方法
    },
    // 获取是否有外部文件
    async  getStorage () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      await this.axios({
        method: 'post',
        url: Outil.getUrl('/advance-setting/storage'),
        data: {
          programId: ProgramId
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            if (result.accessKey && result.secretKey) {
              this.isAll = true
            } else {
              this.isAll = false
            }
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取节点内容
    async  getNodeContent (data, resolve, type) {
      // await this.getStorage()
      let param
      if (data) {
        param = {
          parentId: data.data.id,
          objectKey: data.data.objectKey,
          bucketCode: this.bucket,
          allS3: false,
          fileFrom: data.data.fileFrom
        }
      } else {
        // let allS3
        // if (this.isAll) {
        //   allS3 = true
        // } else {
        //   allS3 = false
        // }
        param = {
          parentId: 0,
          bucketCode: this.bucket,
          allS3: true
        }
      }
      let url
      if (type) {
        url = '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/refresh'
        this.searchFileLoading = true
      } else {
        url = '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/getFolderAndMedias'
      }

      this.axios.post(
        url,
        param,
        {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      )
        .then((res) => {
          if (param.parentId == 0) this.RefreshSwitch = true
          if (res.data.errorCode == '0x0') {
            const FileList = res.data.result
            if (param.parentId == 0) {
              this.driveId = FileList && FileList.length > 0 && FileList[0].driveId
              // FileList = res.data.result
              // FileList = this.FilterFolder(res.data.result)
            }
            // 去除不应该显示的文件
            const filterList = FileList.filter((item) => item.visible)
            if (filterList.length > 0) {
              resolve(filterList)
            } else {
              resolve([
                {
                  noData: true,
                  directory: true
                }
              ])
            }

            this.$nextTick(() => {
              Bus.$emit('leftListUpdate')
            })
            this.searchFileLoading = false
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
            this.searchFileLoading = false
          }
        }).catch(() => {
          if (param.parentId == 0) this.RefreshSwitch = true
        })
    },
    // 时间取整
    TimeINT (folderList) {
      let FileList = []
      if (folderList && folderList.length > 0) {
        folderList.forEach((item) => {
          item.videoDuration = item.videoTimes
          if (this.MediaIsRound) {
            item.videoTimes = item.videoTimes ? Math.floor(Number(item.videoTimes)) : 0
          } else {
            item.videoTimes = item.videoTimes ? Number(item.videoTimes) : 0
          }
        })
        FileList = folderList
      }
      return FileList
    },
    // 过滤文件夹
    FilterFolder (folderList) {
      let FileList = []
      const ProgramRMessage = Outil.getProgramReceiver()
      let showFolders
      if (ProgramRMessage) {
        showFolders = ProgramRMessage.showFolders
      }
      if (showFolders) {
        showFolders = showFolders.toUpperCase()
        const folderNameList = showFolders.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter((item) => folderNameList.includes(item.name.toUpperCase()))
        return FileList
      }
      const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
      if (urlInfo.folderNameList) {
        const folderName = urlInfo.folderNameList.toUpperCase()
        const folderNameList = folderName.split(',')
        // 筛选要显示的文件夹
        FileList = folderList.filter((item) => folderNameList.includes(item.name.toUpperCase()))
      }
      return FileList
    },
    // 搜索显示
    searchShow () {
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeHeaderSearchShow', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeHeaderSearchShow', '/pop')
      }
      this.fileInput = !this.fileInput
      this.searchFileParam.condition = ''
      if (this.searchFileParam.IsSearch) {
        this.presentNode = {
          id: this.NodeHeadId
        }
        this.ClearParentMap()
        this.operationSuccess()
      }
      this.searchFileParam.IsSearch = 0
      if (this.fileInput) {
        this.$nextTick(() => {
          this.$refs.ResourceSearch.focus()
        })
      }
      this.emptySelect()
    },
    // 清除节点
    ClearParentMap () {
      const FirstNode = this.parentMap[this.NodeHeadId]
      this.parentMap = {}
      this.parentMap[this.NodeHeadId] = FirstNode
    },
    // 搜索文件
    getSearchFile () {
      componentsAnalyze('publicFileTreeGetSearchFile', '/ponent')
      this.searchFileLoading = true
      this.searchFileParam.IsSearch++
      const condition = this.searchFileParam.condition
      this.searchFileParam.condition = condition.replace(/(^\s*)|(\s*$)/g, '')
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/getFolderAndMediasByCondition',
          {
            condition: this.searchFileParam.condition,
            parentId: 0,
            bucketCode: this.bucket
          },
          {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.searchFileLoading = false
            // const FileList = res.data.result
            // const FileList = this.FilterFolder(res.data.result)
            const FileList = res.data.result
            // 去除不应该显示的文件
            const filterList = FileList.filter((item) => item.visible)
            this.searchFileList = filterList
            this.emptySelect()
            this.$nextTick(() => {
              Bus.$emit('leftListUpdate')
            })
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
            this.searchFileLoading = false
          }
        }).catch(() => {
          this.searchFileLoading = false
        })
    },
    // 判断是否是json
    IsJson (node) {
      if (node.data && Outil.FileNameSuffix(node.data.name) == 'json') {
        return true
      } else {
        return false
      }
    },
    // 下载josn文件
    DownloadJson (node) {
      // const download = document.createElement('a')
      // download.href = node.data.url
      // download.download = node.data.name
      // download.click()
      // download.remove()
      const url = node.data.url
      const name = node.data.name
      const fileName = name.slice(0, name.lastIndexOf('.'))
      fetch(url).then((data) => data.text()).then((data) => {
        const datastr = `data:text/json;charset=utf-8,${data}`
        const downloadAnchorNode = document.createElement('a')
        downloadAnchorNode.setAttribute('href', datastr)
        downloadAnchorNode.setAttribute('download', `${fileName}.json`)
        downloadAnchorNode.click()
        downloadAnchorNode.remove()
      })
    },
    // 文件编辑
    changeFile (node) {
      if (this.CloneDisabled.VideoEdit || this.CloneDisabled.disableButton) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeEditFile', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeEditFile', '/pop')
      }
      if (node.data && Outil.FileNameSuffix(node.data.name) == 'json') {
        const RegionBucket = this.$BehaviorSyns.getRegionBucket()
        const ProgramMessgae = Outil.getProgramReceiver()
        const ownerUserId = ProgramMessgae && ProgramMessgae.ownerUserId
        Outil.getJsonMessage(node.data, RegionBucket.region, ownerUserId).then((res) => {
          if (res.data.errorCode == '0x0') {
            if (res.data.result && res.data.result.data) {
              // 编辑文件信息
              this.currentData = node.data
              this.SearchEditing(res.data.result)
            } else {
              this.$message.info('Clips are not currently supported for this file')
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
      } else {
        this.editMedia = {
          ...node.data,
          show: true
        }
      }
      // 不是搜索的文件进行编辑
      if (!this.searchFileParam.IsSearch) {
        // 编辑文件存父级节点
        this.presentNode = node.parent
      }
    },
    // 获取录制文件信息
    getRecordMessage (file) {
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/record/search/info',
          {
            name: file.name
          },
          {
            contentType: 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.SearchEditing(res.data.result)
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 引入TVUSearch
    async SearchEditing (file) {
      const session = Outil.getSession()
      const RegionBucket = this.$BehaviorSyns.getRegionBucket()
      const destinationFolder = file.fileEditOutputPath ? file.fileEditOutputPath : `${this.driveId}/RECORDINGS/EDIT`
      const { urlInfo } = JSON.parse(localStorage.getItem('channelInitConfig'))
      const gatewayPlayoutUrl = `${window.location.protocol}//${urlInfo.gatewayPlayoutUrl}`
      if (!this.CutFolderID) {
        const OwnerUserid = Outil.getProgramReceiver('ownerUserId')
        const Folder = destinationFolder.substr(destinationFolder.indexOf('/'))
        await this.getFolderID(OwnerUserid, Folder)
      }
      let iscn = false
      if (file.data.filePath.indexOf('.amazonaws.com.cn') > -1) {
        iscn = true
      }
      const data = {
        session,
        mediaBucketType: 'S3',	// fixed for now
        mediaBucketName: file.data.storage.bucket,
        mediaBucketRegion: file.data.storage.region,
        mediaFilePath: file.data.storage.path,
        mediaStartTimestamp: file.beginTimestamp,
        destinationBucketName: RegionBucket.bucket,
        destinationBucketRegion: RegionBucket.region,
        destinationFolder,
        fileNamePrefix: '',
        destinationPathID: this.CutFolderID,
        iscn: iscn,
        markerInfo: {
          id: file.data.taskId,
          markerListAPI: `${gatewayPlayoutUrl}/tvu-playout/${file.listRecordScteUri}`
        }
      }
      console.log(data)
      const input = {
        version: '1.0',
        messageType: 'mark',
        origin: 'playout',
        data
      }
      // iframe传参
      this.iframeData = input
      this.isIframeShow = true
      // searchIframe({
      //   open: () => [session, url, input],
      //   event: (e) => {
      //     console.log(e)
      //     this.operationSuccess('compile')
      //   },
      //   error: (e) => {
      //     console.log(e)
      //   },
      //   close: () => {
      //     console.log('close close ')
      //   }
      // })
    },
    // 获取文件夹id
    async getFolderID (userId, Folder) {
      const param = {
        directory: Folder,
        userId,
        bucket: this.bucket
      }
      await this.axios
        .post('/file/get-user-bucket-dir', param, { requestBase: 'GATEWAY' })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.CutFolderID = res.data.result.id
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {})
    },
    // 对文件夹进行操作
    changeFolder (type, node) {
      if ((type == 0 && this.CloneDisabled.VideoAdd) || (type == 1 && this.CloneDisabled.VideoEdit) || this.CloneDisabled.disableButton) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeAddFolder', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeAddFolder', '/pop')
      }
      const urlInfo = JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo
      this.editFolder = {
        show: true,
        ...node.data,
        type
      }
      // 新增文件夹存当前节点
      this.presentNode = node
    },
    // 文件和文件夹操作成功
    async operationSuccess (fileType, FolderMessage) {
      // 新建最外层文件夹
      if (fileType == 'Folder' && !this.editFolder.type && this.editFolder.parentId == 0) {
        await this.NewFolder()
      }
      // fileType文件操作类型 add,compile,delete 文件操作  Folder文件夹
      // 是否事搜索的文件操作
      if (this.searchFileParam.IsSearch) {
        this.getSearchFile()
      } else {
        // 文件移动到其他文件夹
        if (fileType === 'compile' || (fileType == 'Folder' && !this.editFolder.type)) {
          this.presentNode = {
            id: this.NodeHeadId
          }
        } else if (fileType === 'add') {
          this.AddNoRefresh(FolderMessage.Folder)
          // 文件夹未打开进行刷新文件夹树
          if (!this.presentNode.key) {
            this.presentNode = {
              id: this.NodeHeadId
            }
          }
        } else if (fileType === 'compile' || (fileType == 'Folder' && this.editFolder.type)) {
          this.presentNode = {
            id: this.NodeHeadId
          }
        }
        const getNode = this.parentMap[this.presentNode.id]
        if (fileType === 'refresh') {
          this.requestNewData(getNode, 1)
        } else if (getNode) {
          this.requestNewData(getNode, 0)
        }
      }
    },
    // 新增文件不全部刷新
    AddNoRefresh (folderId) {
      for (const key in this.parentMap) {
        const item = this.parentMap[key]
        // 文件夹未打开存文件夹
        if (item.node.data && item.node.data.id == folderId) {
          this.presentNode = {
            id: key,
            key: true
          }
        }
      }
    },
    // 文件数量变化
    FileNumber (getNode, Type, Number) {
      if (getNode.node.parent) {
        const CurrentNode = this.parentMap[getNode.node.parent.id]
        if (CurrentNode.node.data) {
          if (Type == 'add') {
            if (Number) {
              CurrentNode.node.data.mediaCount += Number
            } else {
              CurrentNode.node.data.mediaCount++
            }
          } else {
            if (Number) {
              CurrentNode.node.data.mediaCount -= Number
            } else {
              CurrentNode.node.data.mediaCount--
            }
            CurrentNode.node.data.mediaCount < 0 && (CurrentNode.node.data.mediaCount = 0)
          }
        }
        this.FileNumber(CurrentNode, Type, Number)
      }
    },
    // 新建文件夹
    async NewFolder () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      await this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/program/getProgram',
          {
            programId: ProgramId
          },
          {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            if (res.data.result) {
              const ProgramRMessage = Outil.getProgramReceiver()
              if (ProgramRMessage && res.data.result.showFolders) {
                ProgramRMessage.showFolders = res.data.result.showFolders
                sessionStorage.setItem('ProgramRMessage', JSON.stringify(ProgramRMessage))
              }
            }
          }
        }).catch(() => {})
    },
    // 点击文件预览视频
    async getCurrentNode (data, node) {
      if (data.url) {
        componentsAnalyze('publicFileTreeGetCurrentNode', '/ponent')
        const suffix = Outil.FileNameSuffix(data.url)
        let PreviewData = JSON.parse(JSON.stringify(data))
        let BitRate = 0
        if (PreviewData.fileLength && PreviewData.videoTimes) {
          const fileLength = Number(PreviewData.fileLength) / 1024
          const videoTimes = Number(PreviewData.videoTimes)
          BitRate = (fileLength / videoTimes) * 8
        }
        if ((suffix == 'json' || suffix == 'mp4') && BitRate < 10000) {
          if (PreviewData.fileFrom) {
            PreviewData = await this.getAmazonS3Url(PreviewData)
          }
          this.$emit('SetPreviewVideo', PreviewData, 'Media')
        } else {
          const objSourceR = {}
          objSourceR.sourceData = data
          objSourceR.type = 'ext'
          this.$emit('SetPreviewVideo', data, 'ext')
          Bus.$emit('palySourceVideo', objSourceR)
        }
      }
    },
    // 获取外部S3地址
    async getAmazonS3Url (data) {
      await this.axios.post(Outil.getUrl('/preview/preMP4Url'), {
        programId: this.$BehaviorSyns.getProgramId(),
        objectKey: data.objectKey,
        driveId: data.driveId,
        fileFrom: data.fileFrom
      })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            data.url = res.data.result
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        }).catch(() => {
        })
      return data
    },
    // 新增文件夹
    showAddFolder () {
      if (this.CloneDisabled.VideoAdd || this.CloneDisabled.disableButton) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeHeaderAddFolder', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeHeaderAddFolder', '/pop')
      }
      this.editFolder = {
        show: true,
        name: '',
        parentId: '',
        id: '0',
        type: 0
      }
    },
    // 上传视频
    showUploadVideo () {
      if (this.CloneDisabled.VideoAdd || this.CloneDisabled.disableButton) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeHeaderUploadVideoFile', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeHeaderUploadVideoFile', '/pop')
      }
      this.uploadVideo.show = true
    },
    // 删除文件夹
    deleteFolder (node) {
      if (this.CloneDisabled.VideoDelete || this.CloneDisabled.disableButton) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeDeleteFolder', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeDeleteFolder', '/pop')
      }
      this.$confirm(this.$t('lang.deleteFolder'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        // 编辑文件夹存父级节点
        this.presentNode = node.parent
        this.axios
          .post(
            '/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/deleteFolder',
            {
              id: node.data.id,
              bucketCode: this.bucket,
              sessionId: Outil.getSession()
            },
            {
              contentType: 'application/json;charset=UTF-8'
            }
          )
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              this.$message({
                type: 'success',
                message: this.$t('lang.success')
              })
              this.operationSuccess('deleteFolder', {
                Number: node.data.mediaCount
              })
            } else {
              const errorInfo =
                this.$t(toTips[res.data.errorCode]) ||
                res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }).catch(() => {})
      }).catch(() => {})
    },
    // 删除文件
    deleteFile (node) {
      if (this.CloneDisabled.VideoDelete || this.CloneDisabled.disableButton) return
      if (this.pageMark === '/po') {
        scheduleAnalyze('schedulerFileTreeDeleteFile', '/po')
      }
      if (this.pageMark === '/pop') {
        playoutAnalyze('playoutFileTreeDeleteFile', '/pop')
      }
      this.$confirm(this.$t('lang.IsBatchDelete'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        // 不是搜索的文件进行编辑
        if (!this.searchFileParam.IsSearch) {
          // 编辑文件存父级节点
          this.presentNode = node.parent
        }
        const ProgramId = this.$BehaviorSyns.getProgramId()
        this.axios
          .post(
            '/gatewayPlayoutUrl/tvu-playout/fileInfoNew/schedule/event/exist/check',
            {
              fileIds: [node.data.id],
              programId: ProgramId
            }
          )
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              // 判断是否可以直接删除
              if (res.data.result != null) {
                this.HintMessageList.switch = true
                this.HintMessageList.isBatch = false
                this.HintMessageList.node = node
                this.HintMessageList.list = res.data.result
              } else {
                this.AgainDeleteFile(false, node)
              }
            } else {
              const errorInfo =
                this.$t(toTips[res.data.errorCode]) ||
                res.data.errorInfo
              this.$message.info(errorInfo)
            }
          })
      }).catch(() => { })
    },
    // 再一次删除文件
    AgainDeleteFile (type, node, update) {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      this.HintMessageList.loading = true
      let fileIds = []
      // 是否批量删除
      if (type) {
        fileIds = node
      } else {
        fileIds = [node.data.id]
      }
      this.axios
        .post(
          '/gatewayPlayoutUrl/tvu-playout/fileInfoNew/file/delete',
          {
            fileIds,
            programId: ProgramId
          },
          {
            contentType: 'application/json;charset=UTF-8'
          }
        )
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('lang.success')
            })
            if (update == 'UpdateEvent') {
              // 通过websocket通知更新event
              this.$BehaviorSyns.SendBehavior('EventListChange', 1)
            }
            if (type) {
              this.BatchRefreshFolder()
            } else {
              this.operationSuccess('delete')
            }
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) ||
              res.data.errorInfo
            this.$message.info(errorInfo)
          }
          this.HintMessageList.switch = false
          this.HintMessageList.loading = false
        }).catch(() => {
          this.HintMessageList.switch = false
          this.HintMessageList.loading = false
        })
    },
    // 批量删除文件
    batchDelete () {
      if (this.CloneDisabled.VideoDelete || this.CloneDisabled.disableButton) return
      const keys = Object.keys(this.PitchOnFileList)
      if (keys.length <= 0) return
      this.$confirm(this.$t('lang.IsBatchDelete'), '', {
        confirmButtonText: this.$t('lang.Confirm'),
        cancelButtonText: this.$t('lang.cancel'),
        type: ''
      }).then(() => {
        const ProgramId = this.$BehaviorSyns.getProgramId()
        this.axios
          .post(
            '/gatewayPlayoutUrl/tvu-playout/fileInfoNew/schedule/event/exist/check',
            {
              fileIds: keys,
              programId: ProgramId
            }
          )
          .then((res) => {
            if (res.data.errorCode == '0x0') {
              // 判断是否可以直接删除
              if (res.data.result != null) {
                this.HintMessageList.switch = true
                this.HintMessageList.isBatch = true
                this.HintMessageList.node = keys
                this.HintMessageList.list = res.data.result
              } else {
                this.AgainDeleteFile(true, keys)
              }
            } else {
              const errorInfo =
                this.$t(toTips[res.data.errorCode]) ||
                res.data.errorInfo
              this.$message.info(errorInfo)
            }
          }).catch(() => { })
      }).catch(() => { })
    },
    // 批量刷新文件夹
    BatchRefreshFolder () {
      this.emptySelect()
      const keys = Object.keys(this.multipleFileFolder)
      keys.forEach((key) => {
        const parentId = this.multipleFileFolder[key]
        const getNode = this.parentMap[parentId.id]
        if (getNode) {
          this.requestNewData(getNode, 0)
        }
      })
      this.multipleFileFolder = {}
    },
    // 提示后确认删除
    ConfirmDelete (type) {
      this.AgainDeleteFile(type, this.HintMessageList.node, 'UpdateEvent')
    },
    // 取消删除
    CancelBatchDelete () {
      this.HintMessageList.switch = false
      this.HintMessageList.loading = false
      this.HintMessageList.node = null
    },
    formatSeconds (i, name) {
      return Outil.changgeformatSeconds(i, name)
    }
  },
  beforeDestroy () {
    this.emptySelect()
  }
}
</script>

<style scoped lang="less">
.PublicFileTree {
  height: 100%;
  i {
    color: #cccccc;
  }
  .FileTreeTop {
    .searchTitle {
      padding: 12px 0 10px 0;
      border-bottom: 2px solid #555;
      text-align: right;
      i {
        margin: 0 4px;
        color: #cccccc;
      }
      .icon-refresh{
        font-size: 17px;
      }
      .selected{
        color: #38AB52;
      }
    }
    .searchInput {
      position: relative;
      ::v-deep .el-input__inner {
        padding-right: 45px;
      }
      i {
        position: absolute;
        right: 12px;
        font-size: 20px;
        top: 7px;
        z-index: 1001;
      }
    }
  }
  .FileTreeScroll {
    height: calc(100% - 90px);
    overflow-y: auto;
  }
  .FileTreeScroll::-webkit-scrollbar:horizontal {
    display: none;
  }
  .draggable_box {
    margin-top: 5px;
    ::v-deep .el-tree {
      .el-tree-node__content {
        height: 32px;
        .el-icon-caret-right:before {
          font-size: 16px;
        }
        .el-icon-loading {
          display: none;
        }
      }
      .TreeWrap {
        // width: 90%;
        width: calc(100% - 28px);
        .folderItem,
        .draggable_item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 32px;
          position: relative;
          .checkbox{
            position: absolute;
            top: -4px;
            left: 0px;
            transform: translate(-100%);
            margin-left: -5px;
            .checkWrap{
              span{
                display: inline-block;
                width: 17px;
                height: 17px;
                border-radius: 50%;
                background: #38AB52;
                color: #FFFFFF;
                line-height: 17px;
                transform: scale(0.7);
                font-size: 12px;
              }
            }
            .icon-checkbox1{
              color: #38AB52;
            }
            i {
              font-size: 12px;
            }
          }
          .fileTitle {
            width: 60%;
            font-size: 12px;
            color: #cccccc;
            text-align: left;
            overflow: hidden;
            margin: 0;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .folderOperation {
            width: 40%;
            padding-right: 6px;
            text-align: right;
            i {
              font-size: 16px;
              margin-right: 6px;
            }
          }
          .fileOperation {
            width: 40%;
            .IconWrap {
              display: none;
              text-align: right;
              padding-right: 6px;
              i {
                font-size: 16px;
                margin-right: 6px;
              }
              .icon-download{
                font-size: 12px;
                margin-right: 8px;
              }
            }
            .FileTime {
              font-size: 12px;
              color: #cccccc;
              line-height: 14px;
              display: block;
              text-align: right;
            }
            // .FileTimeOld {
            //     font-size: 12px;
            //     color: #cccccc;
            //     line-height: 14px;
            //     display: block;
            // }
          }
        }
        .folderItem:hover .folderOperation {
          // display: block;
        }
        .draggable_item:hover .fileOperation {
          .IconWrap {
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
          .FileTime {
            display: none;
          }
        }
      }
    }
  }
  .SelectTotalNumber{
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    white-space: nowrap;

    span {
      color: #38AB52;
    }
    .batchDelete {
      display: inline-block;
      margin-left: 15px;
      margin-right: 5px;
    }
  }
}
</style>
